// Components
import { IconButton, InputAdornment } from "@mui/material";
import { Clear } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";

// Libraries
import { DateTime } from "luxon";

// Helpers
import {
  getFormikHelperTextState,
  getHelperTextWithAction,
} from "./formikHelperText";

const FormikDatePicker = ({ formik, field }) => {
  const isRequired = field.required ?? true;
  const isClearable = Boolean(field.clearable);
  const hasValue = Boolean(formik.values[field.id]);
  const labelText =
    field.label && isRequired ? `${field.label} *` : field.label;
  const { hasError, helperTextContent } = getFormikHelperTextState({
    formik,
    name: field.id,
    baseHelperText: field.helperText,
    hideErrorText: field.hideErrorText,
    showHelperTextWithError: field.showHelperTextWithError,
  });
  const helperText = getHelperTextWithAction({
    helperTextContent,
    helperTextAction: field.helperTextAction,
  });

  return (
    <DatePicker
      format="yyyy-MM-dd"
      label={labelText}
      views={["year", "month", "day"]}
      id={field.id}
      disableFuture={field.disableFuture ?? true}
      maxDate={DateTime.now()}
      value={formik.values[field.id]}
      onChange={(value) => {
        formik.setFieldValue(field.id, value);
      }}
      onBlur={formik.handleBlur}
      slotProps={{
        textField: ({ InputProps, ...params }) => ({
          ...params,
          variant: field.variant || "outlined",
          error: hasError,
          helperText,
          slotProps: {
            ...params.slotProps,
            formHelperText: {
              ...params.slotProps?.formHelperText,
              component: "div",
              sx: {
                whiteSpace: "pre-line",
                ...(params.slotProps?.formHelperText?.sx || {}),
              },
            },
          },
          sx: { width: "100%", ...field.sx },
          InputProps: {
            ...InputProps,
            endAdornment: (
              <>
                {isClearable && hasValue && !field.disabled && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={`Clear ${field.label || field.id}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        formik.setFieldValue(field.id, null);
                      }}
                      edge="end"
                      size="small"
                      sx={{ p: "0.25rem" }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )}
                {InputProps?.endAdornment}
              </>
            ),
          },
        }),
      }}
      disabled={field.disabled}
      sx={field.datePickerSx}
    />
  );
};

export default FormikDatePicker;
